

<div class="container">
  <div #modelContainer class="configuration-panel" fxLayout="row" fxLayoutAlign="center center">
    <model-viewer id="glb-product-link" style="width: 100vw; height: 100vh;"
      camera-controls
      touch-action="pan-y"
      [exposure]="exposureValue"
      [shadow-intensity]="shadowIntensityValue"
      [src]="url"
      [ios-src]="urlIos"
      [poster]="posterUrl"
      data-js-focus-visible=""
      alt="Model preview"
      min-camera-orbit="auto auto 10%" max-camera-orbit="auto auto 100%"
      min-field-of-view="45deg" max-field-of-view="90deg"
      auto-rotate
      ar
      ar-modes="scene-viewer webxr quick-look"
      ar-status="not-presenting"
      environment-image="https://cdn.situsystems.com/products/small_empty_room_3_4k.hdr"
      environment-image-intensity="0.35"
      camera-orbit="225deg 55deg auto">
    </model-viewer>
    <div class="model-viewer-controls" fxLayout="row" fxLayoutAlign="end center">
      <div fxLayout="row" fxLayoutAlign="end center">
        <mat-icon matTooltip="Exposure">wb_sunny</mat-icon>
        <mat-slider
          min="0"
          max="3"
          step="0.1"
          thumbLabel 
          [(ngModel)]="exposureValue"
          (input)="onExposureChange($event)"
          tickInterval="0.5">
        </mat-slider>
        <!-- <span>{{exposureValue | number: '1.1-1'}}</span> -->
      </div>
      <div *ngIf="false" fxLayout="row" fxLayoutAlign="end center">
        <mat-icon matTooltip="Shadow Intensity">brightness_6</mat-icon>
        <mat-slider
          min="0"
          max="1"
          step="0.1"
          thumbLabel 
          [(ngModel)]="shadowIntensityValue"
          (input)="onShadowIntensityChange($event)"
          tickInterval="0.1">
        </mat-slider>
        <!-- <span>{{shadowIntensityValue | number: '1.1-1'}}</span> -->
      </div>
    </div>
    <div class="homeconfig" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="4px">
      <a target="_blank" href="https://situsystems.com/"><img class="logo" src="https://cdn.situsystems.com/facade/2d7f08ea-ccdc-4c39-85ce-4e987ea79e65.png" alt="situSYSTEMS" matTooltip="situSYSTEMS"></a> 
    </div>
  </div>
</div>